export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23')
];

export const server_loads = [];

export const dictionary = {
		"/": [5],
		"/buttons": [6],
		"/functions": [7,[2]],
		"/functions/contexts": [8,[2]],
		"/inputs": [9],
		"/recipes": [10,[3]],
		"/recipes/dynamic-highlight": [11,[3]],
		"/recipes/gallery": [12,[3]],
		"/recipes/inverted-border": [13,[3]],
		"/recipes/navigation": [14,[3]],
		"/recipes/orderable-list": [15,[3]],
		"/tooltips": [16],
		"/wrappers": [17,[4]],
		"/wrappers/accordion": [18,[4]],
		"/wrappers/modal": [19,[4]],
		"/wrappers/tables": [20,[4]],
		"/wrappers/tabs": [21,[4]],
		"/wrappers/transition": [22,[4]],
		"/wrappers/transition/[image]": [23,[4]]
	};

export const hooks = {
	handleError: (({ kind, error }) => { if (kind === 'unknown') { console.error(error); } }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);